import { render, staticRenderFns } from "./private_renew.vue?vue&type=template&id=33d0440e&scoped=true&"
import script from "./private_renew.vue?vue&type=script&lang=js&"
export * from "./private_renew.vue?vue&type=script&lang=js&"
import style0 from "./private_renew.vue?vue&type=style&index=0&id=33d0440e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d0440e",
  null
  
)

export default component.exports